import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import classnames from 'classnames';
import {
  Label,
  Input,
} from 'reactstrap';
import { useIntl } from 'react-intl';

import HelpIcon from '../HelpIcon';
import UpgradePlanButton from '../UpgradePlanButton';

import {
  userIsAdmin,
  userIsManager,
} from '../../helpers/Auth';
import { userHasFeature } from '../../helpers/Features';
import { canUserManageShare } from '../../helpers/Share';

const ShareModalShowPeople = (({
  showPeople,
  hideFileDetails,
  handleChangeShowPeople,
  handleClose,
}) => {
  const intl = useIntl();

  const disabled = hideFileDetails || !canUserManageShare();

  return (
    <div className="share-show-people share-setting">
      <Label for="inpShowPeople" className={classnames('switch', { disabled })}>
        <span>
          {intl.formatMessage({ defaultMessage: 'Show People tab' })}
        </span>
        <div className="share-setting-switch-wrapper">
          <UpgradePlanButton feature="face-recognition" simple={true} />
          {hideFileDetails && (
            <HelpIcon id="share-show-people-disabled" permanent={true}>
              {intl.formatMessage({ defaultMessage: 'Enable file details to show People tab' })}
            </HelpIcon>
          )}
          {userHasFeature('face-recognition') && (
            <div className="switch-control input-inner">
              <Input
                type="checkbox"
                name="show-people"
                id="inpShowPeople"
                value={true}
                checked={showPeople}
                disabled={disabled}
                onChange={handleChangeShowPeople}
              />
              <i />
            </div>
          )}
        </div>
      </Label>
      {((userIsAdmin() || userIsManager()) && !userHasFeature('face-recognition')) && (
        <div className="restricted-notice">
          {intl.formatMessage({ defaultMessage: 'Enable facial recognition in your <link>workspace settings</link>' }, {
            link: (msg) => (
              <Link to="/admin/settings/ai-tagging" onClick={handleClose}>
                {msg}
              </Link>
            ),
          })}
        </div>
      )}
    </div>
  );
});

ShareModalShowPeople.propTypes = {
  showPeople: PropTypes.bool.isRequired,
  hideFileDetails: PropTypes.bool.isRequired,
  handleChangeShowPeople: PropTypes.func.isRequired,
  handleClose: PropTypes.func,
};

ShareModalShowPeople.defaultProps = {
  handleClose: () => {},
};

export default ShareModalShowPeople;
